require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-steinberg-doerfl.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-steinberg-doerfl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-steinberg-doerfl!./.cache/json/betreuungseinrichtungen-oberpullendorf-steinberg-doerfl.json
// module id = 993
// module chunks = 231608221292675